import React from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { MobilePlayerBar } from "./mobile-player-bar";
import { DesktopPlayer } from "./desktop-player";
export var Player = function (_a) {
    var containerClassName = _a.containerClassName, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b;
    var theme = useTheme();
    var showMobilePlayer = useMediaQuery(theme.breakpoints.down("sm"));
    return showMobilePlayer ? (React.createElement(MobilePlayerBar, { containerClassName: containerClassName, fullWidth: true })) : (React.createElement(DesktopPlayer, { containerClassName: containerClassName, fullWidth: fullWidth }));
};
